import { useMemo, useCallback, useState } from 'react';
import { BaseNewAndDetail, getDarkThemeClass, defErrProps } from '../../utility';
import { useTheme } from '@emotion/react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import _MetrcTagsTab from './_MetrcTagsTab';
import _PackageTagsTab from './_PackageTagsTab';
import { ItemBreadCrumbs } from '../../utility/BreadcrumbLinks'; 

const baseEntityName = 'Metrc Tags';
const baseEndpointCheck = false;

const plantTagsKey = 'Plant Tags';
const packageTagsKey = 'Package Tags';

const tabEntityMap = [
    { key: plantTagsKey, label: 'Plant Tags', defaultForDetail: true, validForNew: false },
    { key: packageTagsKey, label: 'Package Tags', defaultForDetail: false, validForNew: false },
];


const tel = (setValues) => (res) => {
    const { data = [] } = res;
    let stateValues = {}
    for (let [key, value] of Object.entries(data)) {
        stateValues = { ...stateValues, [key]: value?.results ?? value }
    }
    setValues(state => ({ ...state, ...stateValues, farmsWizard: stateValues?.rooms?.length === 0 }));
}

const handleErrorWithFeedback = feedbackCX => (handleSetValues, errPropsFn) => err => {
    console.log('error occurred');
    handleSetValues('error', true);
    handleSetValues('loading', true);
    const errProps = errPropsFn?.(err) ?? defErrProps;
    feedbackCX?.setContextValue?.(true, errProps);
}

export default function MetrcTags(props) { 
    const [values, setValues] = useState({});
    const navigate = useNavigate();
    const theme = useTheme();
    const currDarkThemeClass = useMemo(() => getDarkThemeClass(theme), [theme]);
    const [searchParams] = useSearchParams();
    const tab = searchParams.get('tab') || 'MetrcTags';

    const toDisable = () => {
        switch (tab) {
            default:
                return true;
        }
    }

    const handleSetValues = useCallback((prop, value) => setValues(state => ({ ...state, [prop]: value })), [setValues]);
    const handleSetLoading = prop => value => handleSetValues('loading', { ...values?.loading, [prop]: value });

    const handleEntityEntryCreateRes = prop => res => {
        handleSetLoading(prop)(false);
        const { data } = res;
        const newState = data?.length > 0 ? [...values?.[prop], ...data] : [...values?.[prop], data];
        handleSetValues(prop, newState);
        return Promise.resolve({ success: true });
    }

    const handleEntityEntryModifyRes = prop => res => {
        const { data } = res;
        handleSetValues(prop, values?.[prop]?.map(e => e.id === data.id ? data : e))
        return Promise.resolve({ success: true });
    };

    const getDefaultTabForEndpoint = () => tabEntityMap?.find(tab => tab?.defaultForDetail)?.key;

    const metrcTagsprops = {
        currDarkThemeClass,
        strains: values?.strains,
        openStrainsPopup: values?.openStrainsPopup ?? false,
        addNew: values?.add ?? false,
        update: values?.update ?? false,
        handleErrorWithFeedback,
        handleEntityEntryCreateRes,
        handleEntityEntryModifyRes,
        handleSetValues
    }

    const tabContentMap = {
        [plantTagsKey]: <_MetrcTagsTab {...metrcTagsprops} />,
        [packageTagsKey]: <_PackageTagsTab {...metrcTagsprops} />,
    };

    const handleSave = () => {
        console.log("Everything is up to date")
    }

    const defShowSaveBtn = () => false;

    
    const breadcrumbsProps = { currLink: tab, currDarkThemeClass, navigate };
    const breadcrumbs = <ItemBreadCrumbs {...breadcrumbsProps} />;

    const baseProps = {
        baseEntityName,
        baseid: undefined,
        currDarkThemeClass,
        tabContentMap,
        tabEntityMap,
        breadcrumbs, 
        createBaseEntityMsg: '',
        baseEndpointCheck,
        enablePopup: true,
        showSaveBtn: defShowSaveBtn,
        toDisable,
        handleSave,
        getDefaultTabForEndpoint
    }

    return <BaseNewAndDetail {...baseProps} />;
}
